import {
  CheckboxProps,
  FormControlLabel,
  FormControlLabelProps,
  Checkbox as MuiCheckbox,
} from '@mui/material'
import { Controller } from 'react-hook-form'

type SmartCheckboxProps = Pick<FormControlLabelProps, 'label'> &
  CheckboxProps & {
    control?: any
    name: string
    disabled?: boolean
  }

export default function Checkbox({
  control,
  name,
  label,
  disabled = false,
  ...rest
}: SmartCheckboxProps) {
  return (
    <FormControlLabel
      control={
        <Controller
          name={name}
          control={control}
          defaultValue={false} // ← ensure controlled from the start
          render={({ field: { value, onChange, onBlur, ref, name } }) => (
            <MuiCheckbox
              checked={value}
              onChange={onChange}
              onBlur={onBlur}
              inputRef={ref}
              name={name}
              disabled={disabled}
              {...rest}
            />
          )}
        />
      }
      label={label}
      disabled={disabled}
    />
  )
}
